export default {
  navbar: {
    home: "होम",
    features: "विशेषताएं",
    whyUs: "हम क्यों",
    contactUs: "संपर्क करें",
    faq: "सामान्य प्रश्न"
  },
  home: {
    transformingData: "डेटा प्रबंधन",
    Management: "बदलना",
    decision: "अत्याधुनिक",
    making: "तकनीक के साथ",
    with: "निर्णय",
    cutting: "लेना",
    edge: "",
    technology: "",
    para_01: "कार्रवाई योग्य अंतर्दृष्टि के लिए स्केलेबल डेटा समाधानों के साथ संगठनों को सशक्त बनाना",
    para_02: "i2Pulse एक मजबूत, उपयोगकर्ता के अनुकूल प्लेटफ़ॉर्म है जिसे डेटा संग्रह, प्रबंधन और विश्लेषण को सरल बनाने के लिए डिज़ाइन किया गया है। उन्नत स्वचालन और नवीन सुविधाओं के साथ, यह स्वास्थ्य, शिक्षा, सरकार और गैर-लाभकारी क्षेत्रों के लिए कच्चे डेटा को कार्रवाई योग्य अंतर्दृष्टि में बदल देता है।",
    heading_01: "i2Pulse की मुख्य विशेषताएं और लाभ",
    card_heading_01: "उन्नत डेटा प्रबंधन क्षमताएं",
    card_heading_02: "नेक्स्ट-लेवल यूजर एक्सपीरियंस",
    card_heading_03: "रीयल-टाइम एनालिटिक्स और रिपोर्टिंग",
    card_heading_04: "निर्बाध एकीकरण पारिस्थितिकी तंत्र",
    card_heading_05: "सुरक्षा और अनुपालन",
    card_heading_06: "स्केलेबिलिटी और अनुकूलन",
    card_para_01: "सटीक जानकारी के लिए डायनेमिक फॉर्म निर्माण और डेटा एकत्रीकरण के साथ विश्वसनीय डेटा प्रबंधन।",
    card_para_02: "सहज ज्ञान युक्त यूआई, स्वचालित वर्कफ़्लो और भूमिका-आधारित एक्सेस उत्पादकता बढ़ाते हैं।",
    card_para_03: "वास्तविक समय के डेटा-संचालित निर्णय लेने के लिए इंटरएक्टिव डैशबोर्ड और भविष्य कहनेवाला विश्लेषण।",
    card_para_04: "वेब, मोबाइल और कस्टम एपीआई कनेक्शन का समर्थन करते हुए तीसरे पक्ष के टूल के साथ आसानी से एकीकृत होता है।",
    card_para_05: "उन्नत एन्क्रिप्शन और वैश्विक अनुपालन मानक डेटा सुरक्षा और जवाबदेही सुनिश्चित करते हैं।",
    card_para_06: "स्केलेबल आर्किटेक्चर संगठनात्मक विकास और विविध वर्कफ़्लो के अनुकूल होता है।",
    heading_02: "यह कैसे काम करता है",
    para_03: "i2Pulse संपूर्ण डेटा प्रबंधन जीवनचक्र को सुव्यवस्थित करता है, जिससे निर्बाध एकीकरण और डेटा गुणवत्ता सुनिश्चित होती है।",
    dataCollection: "डेटा संग्रह",
    dataManagement: "डेटा प्रबंधन",
    analysisAndReporting: "विश्लेषण और रिपोर्टिंग",
    automation: "स्वचालन",
    heading_03: "क्या आप हमारे साथ शुरुआत करने के लिए तैयार हैं?",
    heading_04: "उद्योगों में डेटा प्रबंधन में बदलाव",
    card_heading_07: "स्वास्थ्य क्षेत्र",
    card_heading_08: "शिक्षा",
    card_heading_09: "सरकारी एजेंसियां",
    card_heading_10: "गैर-लाभकारी और एनजीओ",
    card_para_07: "रोगी डेटा को केंद्रीकृत करता है और पूर्वानुमानित मॉडल के साथ स्वास्थ्य परिणामों की निगरानी करता है।",
    card_para_08: "छात्र डेटा का प्रबंधन करता है, प्रदर्शन को ट्रैक करता है, और रिपोर्टिंग को स्वचालित करता है।",
    card_para_09: "जनगणना संचालन को सरल बनाता है और पार-एजेंसी डेटा एकीकरण को सक्षम बनाता है।",
    card_para_10: "संसाधन आवंटन का अनुकूलन करता है, कार्यक्रम के प्रभाव को ट्रैक करता है, और मोबाइल डेटा संग्रह को सक्षम बनाता है।",
    card_07: {
      list_01: { title: "केंद्रीकृत रोगी रिकॉर्ड", description: "त्वरित पहुंच और बेहतर निर्णय लेने के लिए रोगी डेटा प्रबंधन को सुव्यवस्थित करें।" },
      list_02: { title: "रोग प्रकोप निगरानी", description: "रीयल-टाइम डेटा और जियोस्पेशियल मैपिंग का उपयोग करके प्रकोपों की निगरानी और विश्लेषण करें।" },
      list_03: { title: "स्वास्थ्य परिणाम निगरानी", description: "स्वास्थ्य परिणामों का कुशलतापूर्वक आकलन और सुधार करने के लिए पूर्वानुमानित मॉडल का उपयोग करें।" }
    },
    card_08: {
      list_01: { title: "छात्र एवं शिक्षक डेटा प्रबंधन", description: "छात्र की प्रगति और शिक्षक के प्रदर्शन को प्रभावी ढंग से प्रबंधित और ट्रैक करें।" },
      list_02: { title: "प्रदर्शन ट्रैकिंग", description: "डेटा-संचालित अंतर्दृष्टि के साथ सुधार के लिए प्रवृत्तियों और क्षेत्रों की पहचान करें।" },
      list_03: { title: "स्वचालित रिपोर्टिंग", description: "स्वचालित, अनुकूलन योग्य रिपोर्ट के माध्यम से नियामक अनुपालन को सुव्यवस्थित करें।" }
    },
    card_09: {
      list_01: { title: "जनगणना संचालन सरल", description: "सटीक जनगणना रिपोर्टिंग के लिए बड़े पैमाने पर डेटा संग्रह की सुविधा प्रदान करें।" },
      list_02: { title: "सार्वजनिक सेवा कार्यक्रमों की निगरानी", description: "बेहतर परिणामों के लिए सार्वजनिक सेवा पहलों को ट्रैक और अनुकूलित करें।" },
      list_03: { title: "क्रॉस-एजेंसी डेटा एकीकरण", description: "एकाधिक सरकारी एजेंसियों में निर्बाध डेटा एकीकरण को सक्षम करें।" }
    },
    card_10: {
      list_01: { title: "संसाधन आवंटन अनुकूलन", description: "रीयल-टाइम डेटा के आधार पर प्रभावी ढंग से संसाधन आवंटित करें।" },
      list_02: { title: "कार्यक्रम प्रभाव ट्रैकिंग", description: "जवाबदेही सुनिश्चित करने के लिए कार्यक्रमों की सफलता को मापें।" },
      list_03: { title: "मोबाइल डेटा संग्रह", description: "सीमित इंटरनेट कनेक्टिविटी वाले दूरस्थ क्षेत्रों में डेटा एकत्र करने के लिए मोबाइल-अनुकूल उपकरणों का उपयोग करें।" }
    }
  },
  features: {
    heading_01: "i2Pulse की मुख्य विशेषताएं और लाभ",
    banner_title_01: "उन्नत डेटा प्रबंधन",
    banner_title_02: "नेक्स्ट-लेवल यूजर एक्सपीरियंस",
    banner_title_03: "रीयल-टाइम एनालिटिक्स और रिपोर्टिंग",
    banner_title_04: "निर्बाध एकीकरण पारिस्थितिकी तंत्र",
    banner_title_05: "सुरक्षा और अनुपालन",
    banner_title_06: "स्केलेबिलिटी और अनुकूलन",
    banner_01: {
      list_01: "बड़े डेटासेट के साथ इष्टतम विश्वसनीयता के लिए नवीनतम, सिद्ध तकनीकों पर निर्मित।",
      list_02: "दानेदार, कार्रवाई योग्य अंतर्दृष्टि के लिए बहु-स्तरीय डेटा एकत्रीकरण का समर्थन करता है।",
      list_03: "आपकी आवश्यकताओं के अनुरूप अनुकूलित डेटा संग्रह के लिए गतिशील फॉर्म निर्माण।"
    },
    banner_02: {
      list_01: "सहज और उत्तरदायी यूआई: उपयोग में आसानी के लिए डिज़ाइन किया गया।",
      list_02: "उत्पादकता के लिए स्वचालन: स्वचालित वर्कफ़्लो के माध्यम से डेटा आयात जैसे कार्यों को सुव्यवस्थित करता है।",
      list_03: "भूमिका-आधारित अभिगम नियंत्रण: सुरक्षित पहुंच सुनिश्चित करते हुए भूमिकाओं के आधार पर अनुभव अनुकूलित करता है।"
    },
    banner_03: {
      list_01: "इंटरएक्टिव डैशबोर्ड: तत्काल अंतर्दृष्टि के लिए रीयल-टाइम चार्ट के साथ डेटा की कल्पना करें।",
      list_02: "भविष्य कहनेवाला विश्लेषण: रुझानों की भविष्यवाणी करने के लिए मशीन लर्निंग मॉडल का लाभ उठाएं।",
      list_03: "अनुकूलन योग्य रिपोर्ट: विशिष्ट हितधारक की जरूरतों को पूरा करने के लिए रिपोर्ट तैयार करें।"
    },
    banner_04: {
      list_01: "जीआईएस सिस्टम और आईओटी उपकरणों सहित तीसरे पक्ष के टूल के साथ मूल रूप से एकीकृत होता है।",
      list_02: "निरंतर डेटा पहुंच के लिए वेब और मोबाइल दोनों प्लेटफॉर्म के साथ संगत।",
      list_03: "मौजूदा आईटी सिस्टम के साथ सुचारू कनेक्टिविटी सुनिश्चित करते हुए कस्टम एकीकरण के लिए एपीआई शामिल हैं।"
    },
    banner_05: {
      list_01: "सुरक्षित डेटा संग्रहण और स्थानांतरण के लिए उन्नत एन्क्रिप्शन लागू करता है।",
      list_02: "नियमित सुरक्षा ऑडिट और वैश्विक डेटा संरक्षण मानकों के साथ पूर्ण अनुपालन।",
      list_03: "पारदर्शिता और डेटा अखंडता सुनिश्चित करने के लिए ऑडिट ट्रेल और गतिविधि लॉग।"
    },
    banner_06: {
      list_01: "छोटी टीमों से लेकर बड़े उद्यमों तक, आपके संगठन के विकास के साथ तालमेल बिठाने के लिए डिज़ाइन किया गया।",
      list_02: "अद्वितीय वर्कफ़्लो फिट करने के लिए पूरी तरह से अनुकूलन योग्य मॉड्यूल।",
      list_03: "स्केलेबल आर्किटेक्चर जो प्रदर्शन से समझौता किए बिना हजारों उपयोगकर्ताओं का समर्थन करता है।"
    }
  },
  whyUs: {
    heading_01: "i2Pulse क्यों?",
    heading_02: "क्यों",
    heading_03: "i2Pulse?",
    subHeading_01: "अद्वितीय विक्रय बिंदु जो सफलता की ओर ले जाते हैं",
    card_heading_01: "एंड-टू-एंड समाधान",
    card_heading_02: "नवाचार में सरलता",
    card_heading_03: "वैश्विक पहुंच",
    card_heading_04: "निर्बाध स्केलेबिलिटी",
    card_heading_05: "डेटा सुरक्षा",
    card_heading_06: "आपकी आवश्यकताओं के अनुरूप",
    card_para_01: "i2Pulse एक ऑल-इन-वन प्लेटफॉर्म है जो डेटा प्रबंधन को सरल बनाता है।",
    card_para_02: "i2Pulse जटिल कार्यों को सरल बनाने के लिए उपयोगकर्ता के अनुकूल डिज़ाइन के साथ स्वचालन को मिश्रित करता है।",
    card_para_03: "i2Pulse कभी भी, कहीं भी डेटा तक विश्वसनीय पहुंच प्रदान करता है।",
    card_para_04: "जैसे-जैसे आपका व्यवसाय विकसित होता है, वैसे-वैसे i2pulse भी बढ़ता है।",
    card_para_05: "i2pulse के साथ, आपका डेटा सुरक्षित हाथों में है। हम शीर्ष-स्तरीय सुरक्षा को प्राथमिकता देते हैं।",
    card_para_06: "i2pulse एक आकार-फिट-सभी समाधान नहीं है - इसे आपके अद्वितीय व्यवसाय के लिए अनुकूलित किया गया है।"
  },
  contactUs: {
    heading_01: "ईमेल भेजें",
    heading_02: "हमें एक संदेश छोड़ें",
    or: "या",
    name: "नाम",
    email: "ईमेल",
    contactNumber: "संपर्क नंबर",
    message: "संदेश",
    cancel: "रद्द करें",
    submit: "जमा करें"
  },
  readMore: {
    heading_01: "यह कैसे काम करता है",
    subHeading_01: "संग्रह से लेकर निर्णय लेने तक डेटा प्रबंधन को सुव्यवस्थित करना",
    banner_title_01: "डेटा संग्रह",
    banner_title_02: "डेटा प्रबंधन",
    banner_title_03: "विश्लेषण और रिपोर्टिंग",
    banner_title_04: "स्वचालन",
    banner_01: {
      list_01: "अनुकूलन योग्य फॉर्म: अपनी डेटा संग्रह आवश्यकताओं के लिए विशिष्ट फॉर्म डिज़ाइन करें।",
      list_02: "स्वचालित आयात: मैन्युअल प्रयास को कम करते हुए बाहरी स्रोतों से स्वचालित रूप से डेटा आयात करें।",
      list_03: "रीयल-टाइम डेटा कैप्चर: तत्काल उपयोग के लिए विभिन्न स्रोतों से वास्तविक समय में डेटा एकत्र करें।",
      list_04: "IoT एकीकरण: IoT उपकरणों के साथ आसानी से एकीकृत करें।",
      list_05: "मैन्युअल डेटा प्रविष्टि: उन क्षेत्रों के लिए मैन्युअल प्रविष्टि का समर्थन जहां स्वचालन संभव नहीं है।"
    },
    banner_02: {
      list_01: "उन्नत भंडारण: संरचित और असंरचित डेटा की बड़ी मात्रा को सुरक्षित रूप से स्टोर करें।",
      list_02: "व्यवस्थित डेटा प्रोसेसिंग: डेटा को संसाधित करने के लिए उन्नत तकनीकों का उपयोग करें।",
      list_03: "त्रुटि सत्यापन: त्रुटियों को पहचानने और ठीक करने के लिए अंतर्निहित जांच।",
      list_04: "डुप्लिकेट डिटेक्शन: सिस्टम में डुप्लिकेट को स्वचालित रूप से रोकें।"
    },
    banner_03: {
      list_01: "इंटरएक्टिव डैशबोर्ड: रीयल-टाइम अवलोकन के लिए चार्ट और ग्राफ़ के माध्यम से डेटा की कल्पना करें।",
      list_02: "KPIs: अपने संगठन के उद्देश्यों के केंद्रित विश्लेषण के लिए प्रमुख प्रदर्शन संकेतकों को ट्रैक करें।",
      list_03: "रीयल-टाइम डेटा कैप्चर: वास्तविक समय में डेटा एकत्र करें।",
      list_04: "कस्टम रिपोर्ट: स्वचालित या ऑन-डिमांड रिपोर्ट तैयार करें।"
    },
    banner_04: {
      list_01: "पूर्वनिर्धारित वर्कफ़्लो नियम: दोहराए जाने वाले कार्यों के लिए स्वचालित वर्कफ़्लो बनाएं।",
      list_02: "स्वचालित अलर्ट: सिस्टम स्थिति में महत्वपूर्ण बदलावों के लिए अलर्ट सेट करें।",
      list_03: "रूटीन ऑपरेशंस ऑटोमेशन: रोजमर्रा के कार्यों को स्वचालित रूप से करें।",
      list_04: "कम मानवीय हस्तक्षेप: मानवीय त्रुटियों को कम करें।"
    }
  },
  common: {
    and: "और",
    registerNow: "अभी रजिस्टर करें",
    knowMore: "और जानें",
    learnMore: "और जानें",
    requestDemo: "डेमो का अनुरोध करें",
    "login": "लॉग इन",
  },
  coreCapabilities: {
    tagline: "मुख्य क्षमताएँ",
    heading: "अपने वर्कफ़्लो के अनुसार i2Pulse को कॉन्फ़िगर करें",
    dynamicFormsTitle: "डायनामिक फ़ॉर्म",
    dynamicFormsDesc: "डेटा को आसानी से कैप्चर और सत्यापित करें।",
    liveDashTitle: "लाइव डैशबोर्ड",
    liveDashDesc: "ऑपरेशंस को रियल-टाइम में विज़ुअलाइज़ करें।",
    roleAccessTitle: "भूमिका-आधारित एक्सेस",
    roleAccessDesc: "अपने डिजिटल वातावरण को सुरक्षित रखें।",
    workflowTitle: "वर्कफ़्लो ऑटोमेशन",
    workflowDesc: "मैन्युअल रिपोर्टिंग और कार्यों को समाप्त करें।"
  },
  performanceBanner: {
    title: "प्रोग्राम के प्रदर्शन की एक नज़र में जानकारी",
    subtitle: "रियल-टाइम परिचालन दृश्यता, जो वास्तविक परिणाम देती है।",
    stats: {
      completeness: "डेटा पूर्णता",
      records: "प्रोसेस किए गए रिकॉर्ड",
      locations: "सक्रिय स्थान",
      reports: "स्वचालित रिपोर्ट"
    }
  },
  everyRole: {
    headingPart1: "बनाया गया है",
    headingPart2: "हर भूमिका के लिए",
    subheading: "फील्ड से लेकर बोर्डरूम तक अपने पूरे वर्कफ़्लो को कनेक्ट करें:",
    roles: {
      fieldUsers: {
        title: "फील्ड यूज़र्स",
        desc: "सरल डिजिटल फ़ॉर्म के माध्यम से आसानी से डेटा दर्ज करें।"
      },
      dataManagers: {
        title: "डेटा मैनेजर्स",
        desc: "पूर्ण सटीकता के लिए सबमिशन को तुरंत सत्यापित करें।"
      },
      analysts: {
        title: "विश्लेषक",
        desc: "रुझानों का विश्लेषण करें और गहन, उपयोगी अंतर्दृष्टि प्राप्त करें।"
      },
      leaders: {
        title: "लीडर्स",
        desc: "रियल-टाइम प्रदर्शन डैशबोर्ड के साथ आत्मविश्वास से निर्णय लें।"
      }
    }
  }, versatilePlatform: {
    tagline: "विभिन्न उद्योगों के लिए बहुमुखी",
    headingPart1: "एक लचीला प्लेटफ़ॉर्म, जो आपकी",
    headingPart2: "विशिष्ट आवश्यकताओं को पूरा करने के लिए तैयार है:",
    categories: {
      mAndE: "निगरानी एवं मूल्यांकन (M&E)",
      publicHealth: "सार्वजनिक स्वास्थ्य निगरानी",
      education: "शिक्षा निगरानी",
      compliance: "अनुपालन एवं सेवा वितरण",
      nonprofit: "गैर-लाभकारी प्रभाव मापन",
      enterprise: "एंटरप्राइज़ प्रदर्शन"
    }
  },
  howItWorks: {
    badge: "यह कैसे काम करता है",
    heading: {
      line1: "बेहतर डेटा।",
      line2: "आसान वर्कफ़्लो।",
      highlight: "बेहतर परिणाम।"
    },
    description: "i2Pulse डेटा प्रबंधन के पूरे जीवनचक्र को सुव्यवस्थित करता है—डेटा संग्रह से लेकर विश्लेषण और ऑटोमेशन तक। यह हर चरण में निर्बाध एकीकरण, डेटा की गुणवत्ता और उपयोगी अंतर्दृष्टि सुनिश्चित करता है।",
    reliability: {
      line1: "विश्वसनीयता के लिए बनाया गया।",
      line2: "प्रभाव के लिए डिज़ाइन किया गया।",
      line3: "निर्बाध डेटा। बेहतर निर्णय।"
    },
    features: {
      collection: {
        title: "डेटा संग्रह",
        desc: "किसी भी स्रोत से, ऑनलाइन या ऑफलाइन, रियल-टाइम में सटीक डेटा कैप्चर करें।"
      },
      management: {
        title: "डेटा प्रबंधन",
        desc: "शक्तिशाली प्रबंधन टूल्स के साथ अपने डेटा को व्यवस्थित, सत्यापित और सुरक्षित करें।"
      },
      analysis: {
        title: "विश्लेषण और रिपोर्टिंग",
        desc: "इंटरैक्टिव डैशबोर्ड और कस्टम रिपोर्ट के साथ डेटा को उपयोगी अंतर्दृष्टि में बदलें।"
      },
      automation: {
        title: "ऑटोमेशन",
        desc: "समय बचाने, त्रुटियों को कम करने और उत्पादकता बढ़ाने के लिए वर्कफ़्लो और अलर्ट को स्वचालित करें।"
      }
    },
    cta: "और जानें"
  },
  sectorWiseExamples: {
    badge: "क्षेत्र-विशिष्ट उदाहरण",
    headingPart1: "i2Pulse के साथ",
    headingPart2: "आप क्या बना सकते हैं",
    description: "देखें कि i2Pulse को आपके विशिष्ट क्षेत्र की अनूठी भाषा, मेट्रिक्स और वर्कफ़्लो के अनुरूप कैसे कॉन्फ़िगर किया जा सकता है।",
    cards: {
      health: {
        title: "स्वास्थ्य सूचना प्रबंधन",
        description: "रोग निगरानी, टीकाकरण ट्रैकिंग और स्वास्थ्य केंद्र रिपोर्टिंग फ़ॉर्म कॉन्फ़िगर करें।",
        points: [
          "प्रकोप अलर्ट और क्षेत्रीय कमियों की निगरानी करें",
          "रियल-टाइम में टीकाकरण कवरेज ट्रैक करें",
          "समय पर निर्णय लेने के लिए एकीकृत डैशबोर्ड"
        ]
      },
      education: {
        title: "शिक्षा प्रबंधन",
        description: "व्यापक स्कूल प्रोफ़ाइल बनाएं, छात्र नामांकन ट्रैक करें और दैनिक उपस्थिति की निगरानी करें।",
        points: [
          "जिला प्रदर्शन की आसानी से तुलना करें",
          "ड्रॉपआउट के जोखिमों की समय रहते पहचान करें",
          "संसाधनों के आवंटन को बेहतर बनाएं"
        ]
      },
      government: {
        title: "सरकारी प्रदर्शन निगरानी",
        description: "नागरिक सेवाओं, नगरपालिका प्रदर्शन और सामाजिक सुरक्षा कार्यक्रमों को ट्रैक करें।",
        points: [
          "सेवा वितरण और संतुष्टि को मापें",
          "शिकायतों के समाधान की निगरानी करें",
          "सार्वजनिक डैशबोर्ड के साथ पारदर्शिता सुनिश्चित करें"
        ]
      },
      ngo: {
        title: "NGO कार्यक्रम प्रभाव",
        description: "फील्ड गतिविधियों को विश्वसनीय प्रमाण में बदलें और वास्तविक प्रभाव प्रदर्शित करें।",
        points: [
          "लाभार्थियों की पहुंच और परिणामों को ट्रैक करें",
          "साझेदारों के प्रदर्शन को मापें",
          "डोनर के लिए तैयार प्रभाव रिपोर्ट तैयार करें"
        ]
      },
      enterprise: {
        title: "एंटरप्राइज़ संचालन",
        description: "आंतरिक KPI डैशबोर्ड के साथ वितरित टीमों को एक साथ जोड़ें।",
        points: [
          "शाखाओं के प्रदर्शन की निगरानी करें",
          "अनुपालन और गुणवत्ता को ट्रैक करें",
          "संसाधनों के उपयोग को बेहतर बनाएं"
        ]
      },
      research: {
        title: "अनुसंधान और सर्वेक्षण कार्यक्रम",
        description: "कस्टम सर्वेक्षण और रियल-टाइम अंतर्दृष्टि के साथ डेटा संग्रह को सुव्यवस्थित करें।",
        points: [
          "फील्ड टीमों को कुशलतापूर्वक प्रबंधित करें",
          "रियल-टाइम में डेटा सत्यापित करें",
          "विश्लेषण के लिए स्वच्छ डेटासेट एक्सपोर्ट करें"
        ]
      }
    },
    impactBanner: {
      badge: "प्रभाव प्रदान करने के लिए बनाया गया"
    },
    impactFeatures: {
      domain: {
        title: "क्षेत्र-विशिष्ट",
        description: "अपनी भाषा और वर्कफ़्लो के अनुसार कॉन्फ़िगर करें"
      },
      flexible: {
        title: "लचीला और स्केलेबल",
        description: "अपने कार्यक्रमों और संचालन के विकास के साथ अनुकूलित करें"
      },
      evidence: {
        title: "प्रमाण-आधारित",
        description: "विश्वसनीय डेटा के साथ बेहतर निर्णय लें"
      },
      secure: {
        title: "सुरक्षित और अनुपालनयुक्त",
        description: "एंटरप्राइज़-स्तरीय सुरक्षा और गवर्नेंस के साथ निर्मित"
      },
      impact: {
        title: "प्रभाव के लिए बनाया गया",
        description: "उन परिणामों पर ध्यान केंद्रित करें जो सबसे अधिक मायने रखते हैं"
      }
    }
  }, industrySolutions: {
    badge: "उद्योग समाधान",
    heading: {
      part1: "डेटा प्रबंधन में बदलाव",
      part2: "विभिन्न",
      highlight: "क्षेत्रों में"
    },
    description: "i2Pulse उन उद्योगों के अनूठे वर्कफ़्लो के अनुसार अनुकूलित होता है, जहाँ सटीक डेटा, समय पर रिपोर्टिंग और प्रमाण-आधारित निर्णय सफलता के लिए महत्वपूर्ण हैं।",
    sectors: {
      healthcare: {
        title: "स्वास्थ्य सेवा और सार्वजनिक स्वास्थ्य",
        description: "रोगियों के बेहतर परिणामों के लिए स्वास्थ्य केंद्र के डेटा को केंद्रीकृत करें, रोग निगरानी को ट्रैक करें और संसाधनों के आवंटन को बेहतर बनाएं।",
        features: {
          f1: { label: "परिणाम ट्रैक करें", text: "रोग प्रकोप, सेवा वितरण और स्वास्थ्य संकेतकों की निगरानी करें।" },
          f2: { label: "प्रदर्शन मैप करें", text: "क्षेत्र, जिले या व्यक्तिगत स्वास्थ्य केंद्र के अनुसार मेट्रिक्स देखें।" },
          f3: { label: "रणनीति को बेहतर बनाएं", text: "सक्रिय सार्वजनिक स्वास्थ्य योजना और संसाधन प्राथमिकता निर्धारण में सहायता करें।" }
        }
      },
      education: {
        title: "शिक्षा प्रणालियाँ",
        description: "बेहतर शैक्षणिक परिणामों के लिए छात्र, शिक्षक और संस्थागत डेटा को एक केंद्रीकृत प्लेटफ़ॉर्म पर प्रबंधित करें।",
        features: {
          f1: { label: "मेट्रिक्स की निगरानी करें", text: "नामांकन, उपस्थिति और सीखने के प्रदर्शन को ट्रैक करें।" },
          f2: { label: "अनुपालन स्वचालित करें", text: "मान्यता और संस्थागत रिपोर्टिंग को सुव्यवस्थित करें।" },
          f3: { label: "भविष्य की योजना बनाएं", text: "जिलों और विश्वविद्यालयों के लिए प्रमाण-आधारित शिक्षा योजना को सक्षम बनाएं।" }
        }
      },
      government: {
        title: "सरकारी एजेंसियाँ",
        description: "सुरक्षित, विभिन्न एजेंसियों के बीच डेटा समन्वय के साथ पारदर्शिता, सेवा वितरण और नीति योजना में सुधार करें।",
        features: {
          f1: { label: "डेटा संग्रह आसान बनाएं", text: "जनगणना संचालन और प्रशासनिक डेटा संग्रह को सुव्यवस्थित करें।" },
          f2: { label: "डेटा साइलो समाप्त करें", text: "एजेंसियों के बीच निर्बाध डेटा साझाकरण और रिपोर्टिंग सक्षम करें।" },
          f3: { label: "लीडर्स को सशक्त बनाएं", text: "आत्मविश्वास से नीति-स्तरीय निर्णय लेने के लिए एग्जीक्यूटिव डैशबोर्ड को सक्षम करें।" }
        }
      },
      ngo: {
        title: "गैर-लाभकारी संस्थाएँ और NGO",
        description: "लाभार्थियों को ट्रैक करने, वास्तविक प्रभाव मापने और दाताओं को आत्मविश्वास के साथ रिपोर्ट करने के लिए निगरानी और मूल्यांकन (M&E) को सुव्यवस्थित करें।",
        features: {
          f1: { label: "फील्ड टीम को सशक्त बनाएं", text: "मोबाइल और ऑफलाइन-रेडी फ़ॉर्म के साथ कहीं से भी डेटा एकत्र करें।" },
          f2: { label: "प्रभाव मापें", text: "कार्यक्रम की गतिविधियों, आउटपुट और दीर्घकालिक परिणामों को ट्रैक करें।" },
          f3: { label: "दाताओं से जुड़ें", text: "फंडिंग सुरक्षित करने के लिए पारदर्शी, प्रमाण-आधारित रिपोर्ट तैयार करें।" }
        }
      }
    },
    featuresBanner: {
      f1: {
        title: "एकीकृत प्लेटफ़ॉर्म",
        description: "आपका सारा डेटा। आपकी सभी टीमें। एक विश्वसनीय स्रोत।"
      },
      f2: {
        title: "रियल-टाइम। हर जगह।",
        description: "जब और जहाँ ज़रूरत हो, लाइव डेटा और अंतर्दृष्टि प्राप्त करें।"
      },
      f3: {
        title: "डिज़ाइन से ही सुरक्षित",
        description: "महत्वपूर्ण डेटा की सुरक्षा के लिए एंटरप्राइज़-स्तरीय सुरक्षा।"
      },
      f4: {
        title: "डेटा। निर्णय। प्रभाव।",
        description: "जानकारी को कार्रवाई में बदलें और स्थायी प्रभाव पैदा करें।"
      }
    }
  }
  , governanceAndSecurity: {
    badge: "गवर्नेंस और सुरक्षा",
    heading: {
      part1: "विश्वास, जवाबदेही और",
      part2: "नियंत्रित",
      highlight: "एक्सेस के लिए डिज़ाइन किया गया"
    },
    description: "i2Pulse एक सुरक्षित ऑपरेटिंग वातावरण है, जिसे संवेदनशील, विनियमित और मिशन-क्रिटिकल डेटा की सुरक्षा के लिए बनाया गया है—मरीजों के रिकॉर्ड से लेकर छात्रों और लाभार्थियों की जानकारी तक।",
    features: {
      roles: {
        title: "भूमिका-आधारित अनुमतियाँ",
        description: "एडमिन, डेटा एंट्री टीम, अप्रूवर और बाहरी साझेदारों के लिए सटीक एक्सेस स्तर निर्धारित करें।"
      },
      audit: {
        title: "व्यापक ऑडिट ट्रेल्स",
        description: "हर सबमिशन, बदलाव, अप्रूवल और डेटा एक्सपोर्ट को ट्रैक करके पूरी जवाबदेही सुनिश्चित करें।"
      },
      access: {
        title: "सूक्ष्म एक्सेस नियंत्रण",
        description: "डेटा की दृश्यता को भौगोलिक क्षेत्र, विभाग, सुविधा या विशिष्ट प्रोजेक्ट के आधार पर सीमित करें।"
      },
      compliance: {
        title: "वैश्विक अनुपालन के लिए तैयार",
        description: "मजबूत एन्क्रिप्शन और GDPR-अनुरूप डेटा सुरक्षा प्रथाओं के साथ अपने संचालन को सुरक्षित रखें।"
      }
    },
    banner: {
      heading: "हर स्तर पर अंतर्निहित सुरक्षा",
      items: {
        encryption: {
          title: "एन्क्रिप्शन",
          description: "एंड-टू-एंड डेटा एन्क्रिप्शन सुरक्षा।"
        },
        backups: {
          title: "सुरक्षित बैकअप",
          description: "डेटा रिकवरी के लिए स्वचालित बैकअप।"
        },
        auth: {
          title: "प्रमाणीकरण",
          description: "MFA और मजबूत पासवर्ड सुरक्षा।"
        },
        monitoring: {
          title: "निगरानी",
          description: "24/7 खतरे का पता लगाना और निगरानी।"
        },
        retention: {
          title: "डेटा प्रतिधारण",
          description: "डेटा प्रतिधारण और सुरक्षित निपटान प्रबंधित करें।"
        }
      }
    },
    footerText: "आपका डेटा। आपका विश्वास। हमारी जिम्मेदारी।"
  },
  integrationArchitecture: {
    badge: "इंटीग्रेशन आर्किटेक्चर",
    headingPart1: "i2Pulse को अपने मौजूदा",
    headingPart2: "डिजिटल इकोसिस्टम से कनेक्ट करें",
    description: "एक शक्तिशाली डेटा प्लेटफ़ॉर्म को अलग-थलग काम नहीं करना चाहिए। i2Pulse आपके डेटा इकोसिस्टम के साथ निर्बाध रूप से इंटीग्रेट होता है।",
    diagram: {
      dataSources: "डेटा स्रोत",
      integrations: "इंटीग्रेशन",
      enterpriseSystems: "एंटरप्राइज़ सिस्टम",
      outputs: "आउटपुट और गंतव्य"
    },
    featureList: {
      openApi: { title: "ओपन API कनेक्टिविटी", description: "मजबूत API एंडपॉइंट्स के साथ सुरक्षित, रियल-टाइम सिस्टम-टू-सिस्टम संचार सक्षम करें।" },
      ecosystem: { title: "इकोसिस्टम संगतता", description: "CRM, IoT डिवाइस, मोबाइल एप्लिकेशन और एंटरप्राइज़ रिपोर्टिंग पोर्टल से आसानी से कनेक्ट करें।" },
      gis: { title: "GIS और मैपिंग सपोर्ट", description: "उन्नत लोकेशन-आधारित निगरानी और योजना के लिए Geographic Information Systems (GIS) के साथ इंटीग्रेट करें।" },
      dataImports: { title: "निर्बाध डेटा इम्पोर्ट", description: "लेगेसी डेटाबेस और स्प्रेडशीट से पुराने रिकॉर्ड या नियमित डेटा आसानी से इम्पोर्ट करें।" },
      customConnectors: { title: "कस्टम कनेक्टर्स", description: "विशिष्ट वर्कफ़्लो, वित्तीय प्लेटफ़ॉर्म और प्रोप्राइटरी सिस्टम को कनेक्ट करने के लिए अनुकूलित इंटीग्रेशन सहायता प्राप्त करें।" }
    },
    dataSources: {
      webMobile: "वेब और मोबाइल\nफ़ॉर्म",
      iot: "IoT डिवाइस",
      fieldApps: "फील्ड\nएप्लिकेशन",
      spreadsheets: "स्प्रेडशीट",
      legacyDb: "लेगेसी\nडेटाबेस"
    },
    integrations: {
      restApi: "RESTful APIs",
      webhooks: "Webhooks",
      sftp: "SFTP / FTP",
      secureConnectors: "सुरक्षित कनेक्टर्स"
    },
    enterprise: {
      crm: "CRM सिस्टम",
      erp: "ERP / वित्तीय सिस्टम",
      hr: "HR / पेरोल सिस्टम",
      documentManagement: "दस्तावेज़ प्रबंधन"
    },
    outputs: {
      dashboards: "डैशबोर्ड और\nरिपोर्ट",
      gisMaps: "GIS और मैप्स",
      emailSms: "ईमेल और SMS\nसूचनाएँ",
      dataWarehouses: "डेटा वेयरहाउस",
      thirdParty: "थर्ड-पार्टी\nएप्लिकेशन"
    },
    highlights: {
      secureByDesign: { title: "डिज़ाइन से ही सुरक्षित", description: "एंड-टू-एंड एन्क्रिप्शन, टोकन-आधारित प्रमाणीकरण और भूमिका-आधारित एक्सेस सुनिश्चित करते हैं कि आपका डेटा सुरक्षित रहे।" },
      realTimeSync: { title: "रियल-टाइम सिंक", description: "रियल-टाइम या निर्धारित सिंक्रोनाइज़ेशन के साथ सभी सिस्टम में डेटा को एकसमान रखें।" },
      scalable: { title: "स्केलेबल और भविष्य के लिए तैयार", description: "आधुनिक क्लाउड-नेटिव आर्किटेक्चर पर निर्मित, जो आपकी बढ़ती जरूरतों के साथ स्केल करता है।" },
      reliable: { title: "विश्वसनीय और लचीला", description: "हाई अवेलेबिलिटी, एरर हैंडलिंग और रीट्राई मैकेनिज़्म निर्बाध संचालन सुनिश्चित करते हैं।" },
      developerFriendly: { title: "डेवलपर-फ्रेंडली", description: "तेज़ इंटीग्रेशन के लिए व्यापक API डॉक्यूमेंटेशन, सैंडबॉक्स एनवायरनमेंट और SDKs।" }
    }
  },
  trustedBySectors: {
    headingPart1: "दुनियाभर के विभिन्न",
    headingPart2: "क्षेत्रों के संगठनों का भरोसा",
    sectors: {
      health: "स्वास्थ्य",
      education: "शिक्षा",
      government: "सरकार",
      ngos: "NGO",
      enterprise: "एंटरप्राइज़",
      research: "अनुसंधान"
    }
  },
  faq: {
    badge: "अक्सर पूछे जाने वाले प्रश्न",
    headingPart1: "i2Pulse के बारे में",
    headingPart2: "सामान्य प्रश्न",
    headingHighlight: "i2Pulse",
    description: "i2Pulse कैसे काम करता है और यह आपके संगठन के लिए प्रभाव कैसे पैदा कर सकता है, इसे समझने में आपकी मदद करने के लिए स्पष्ट उत्तर।",
    items: {
      q1: {
        question: "क्या i2Pulse स्प्रेडशीट-आधारित रिपोर्टिंग की जगह ले सकता है?",
        answer: "हाँ। हम मैन्युअल स्प्रेडशीट को संरचित डिजिटल फ़ॉर्म, स्वचालित वर्कफ़्लो और लाइव डैशबोर्ड से बदलते हैं, जिससे आपकी टीम को डेटा का एक विश्वसनीय स्रोत मिलता है।"
      },
      q2: {
        question: "क्या प्लेटफ़ॉर्म को हमारे क्षेत्र के अनुसार कस्टमाइज़ किया जा सकता है?",
        answer: "बिल्कुल। i2Pulse स्वास्थ्य सेवा, शिक्षा, सरकार, NGO और एंटरप्राइज़ संचालन के लिए अत्यधिक कॉन्फ़िगर करने योग्य है और आपके विशिष्ट वर्कफ़्लो और शब्दावली के अनुसार अनुकूलित होता है।"
      },
      q3: {
        question: "क्या i2Pulse अलग-अलग यूज़र परमिशन का समर्थन करता है?",
        answer: "हाँ। सूक्ष्म भूमिका-आधारित एक्सेस के माध्यम से आप यह नियंत्रित कर सकते हैं कि कौन अपने कार्य या भौगोलिक क्षेत्र के आधार पर डेटा देख, संपादित, अप्रूव या एक्सपोर्ट कर सकता है।"
      },
      q4: {
        question: "क्या i2Pulse हमारे मौजूदा सिस्टम के साथ काम कर सकता है?",
        answer: "हाँ। हमारे ओपन APIs और कस्टम कनेक्टर्स आपके मौजूदा CRM, GIS टूल्स, लेगेसी डेटाबेस और एंटरप्राइज़ प्लेटफ़ॉर्म के साथ निर्बाध रूप से इंटीग्रेट होते हैं।"
      },
      q5: {
        question: "क्या i2Pulse रिमोट या फील्ड टीमों के लिए उपयुक्त है?",
        answer: "हाँ। प्लेटफ़ॉर्म मोबाइल-फ्रेंडली और ऑफलाइन-रेडी वर्कफ़्लो प्रदान करता है, जिससे आपकी फील्ड टीमें कम कनेक्टिविटी वाले क्षेत्रों में भी कहीं से महत्वपूर्ण डेटा कैप्चर कर सकती हैं।"
      },
      q6: {
        question: "i2Pulse निर्णय लेने में कैसे सहायता करता है?",
        answer: "हम सुरक्षित डेटा संग्रह को सीधे लाइव डैशबोर्ड, स्वचालित रिपोर्ट और अलर्ट से जोड़ते हैं। इससे नेतृत्व टीम जोखिमों की पहचान, संसाधनों का आवंटन और विश्वसनीय अंतर्दृष्टि के आधार पर तुरंत कार्रवाई कर सकती है।"
      }
    },
    support: {
      heading: "अभी भी कोई सवाल है?",
      description: "हमारी टीम यह समझने में आपकी सहायता करने के लिए तैयार है कि i2Pulse आपके डेटा को उपयोगी प्रभाव में कैसे बदल सकता है।",
      contactBtn: "हमसे संपर्क करें",
      demoBtn: "डेमो शेड्यूल करें"
    }
  },
  dataLifecycle: {
    badge: "यह कैसे काम करता है",
    headingPart1: "संपूर्ण",
    headingHighlight: "डेटा जीवनचक्र",
    description: "अपने डेटा की यात्रा के हर चरण को कनेक्ट करें — फील्ड में पहली बार डेटा कैप्चर करने से लेकर अंतिम एग्जीक्यूटिव निर्णय तक।"
  },
  processSteps: {
    steps: {
      step1: {
        title: "डेटा संग्रह",
        paragraphs: [
          "रूटीन रिपोर्टिंग, फील्ड मॉनिटरिंग या अनुपालन के लिए डायनामिक और लॉजिक-आधारित फ़ॉर्म बनाएं।",
          "अनिवार्य फ़ील्ड, कंडीशनल लॉजिक और अटैचमेंट के साथ वही डेटा कैप्चर करें जिसकी आपको आवश्यकता है।"
        ]
      },
      step2: {
        title: "डेटा सत्यापन",
        paragraphs: [
          "त्रुटियों को आपकी रिपोर्ट तक पहुँचने से पहले ही पकड़ें।",
          "स्वचालित नियम गायब मान, डुप्लिकेट और निर्धारित सीमा से बाहर की एंट्री को तुरंत फ़्लैग करते हैं, जिससे पूर्ण सटीकता सुनिश्चित होती है।"
        ]
      },
      step3: {
        title: "डेटा प्रबंधन",
        paragraphs: [
          "अपनी जानकारी को सुरक्षित रूप से व्यवस्थित करें।",
          "प्रोग्राम, स्थान या यूज़र भूमिका के अनुसार डेटा व्यवस्थित करें ताकि विस्तृत परिचालन विश्लेषण और उच्च-स्तरीय एग्जीक्यूटिव व्यू दोनों को सक्षम किया जा सके।"
        ]
      },
      step4: {
        title: "विश्लेषण और रिपोर्टिंग",
        paragraphs: [
          "कच्चे आँकड़ों को विज़ुअल अंतर्दृष्टि में बदलें।",
          "लाइव डैशबोर्ड, मैप और स्कोरकार्ड बनाएं या विशिष्ट हितधारकों के लिए अनुकूलित स्वचालित रिपोर्ट शेड्यूल करें।"
        ]
      },
      step5: {
        title: "कार्रवाई योग्य निर्णय",
        paragraphs: [
          "विश्वसनीय डेटा को वास्तविक दुनिया के प्रभाव में बदलें।",
          "जोखिमों की पहचान करें, संसाधनों का आवंटन करें और बदलती परिचालन आवश्यकताओं पर पूरे आत्मविश्वास के साथ प्रतिक्रिया दें।"
        ]
      }
    },
    panels: {
      validation: {
        summaryTitle: "सत्यापन सारांश",
        valid: "मान्य",
        warnings: "चेतावनियाँ",
        errors: "त्रुटियाँ",
        issuesTitle: "पाई गई समस्याएँ",
        issues: {
          item1: "'Age' में मान गायब है",
          item2: "डुप्लिकेट एंट्री मिली",
          item3: "'Score' निर्धारित सीमा से बाहर है"
        }
      },
      management: {
        title: "डेटा प्रबंधन",
        records: "{{count}} रिकॉर्ड",
        dropdowns: {
          program: "प्रोग्राम",
          allPrograms: "सभी प्रोग्राम",
          location: "स्थान",
          allLocations: "सभी स्थान",
          role: "यूज़र भूमिका",
          allRoles: "सभी भूमिकाएँ"
        },
        programs: {
          nutrition: "पोषण प्रोग्राम",
          health: "स्वास्थ्य प्रोग्राम",
          wash: "WASH प्रोग्राम",
          education: "शिक्षा प्रोग्राम"
        }
      },
      analysis: {
        overviewTitle: "प्रदर्शन अवलोकन",
        trendTitle: "समय के साथ रुझान",
        mapTitle: "मैप व्यू",
        metrics: {
          totalRecords: "कुल रिकॉर्ड",
          coverage: "कवरेज",
          locations: "स्थान"
        }
      },
      decision: {
        title: "निर्णय केंद्र",
        viewBtn: "देखें",
        items: {
          risk: {
            title: "उच्च जोखिम वाले स्थान",
            sub: "5 स्थान"
          },
          resources: {
            title: "संसाधन आवंटन",
            sub: "अनुकूलित"
          },
          alerts: {
            title: "अलर्ट और सूचनाएँ",
            sub: "3 नए अलर्ट"
          }
        }
      }
    }
  },
  footer: {
    availableOn: "पर उपलब्ध",
    contactEnquiry: "संपर्क करें",
    navigate: "नेविगेट करें",
    usefullLinks: "उपयोगी लिंक",
    footer_para: "क्या आपके कोई प्रश्न हैं या सहायता चाहिए? डेमो या अधिक जानकारी के लिए हमसे संपर्क करें।",
    description: "संगठनों के लिए एक सुरक्षित, स्केलेबल और कॉन्फ़िगर करने योग्य डेटा इंटेलिजेंस प्लेटफ़ॉर्म, जिन्हें विश्वसनीय डेटा, रीयल-टाइम अंतर्दृष्टि और बेहतर निर्णय की आवश्यकता है।",
    allRightsReserved: "सर्वाधिकार सुरक्षित।",
    playStore: "प्ले स्टोर",
    appStore: "ऐप स्टोर",
    home: "होम",
    features: "विशेषताएं",
    whyUs: "हम क्यों",
    contactUs: "संपर्क करें",
    register: "रजिस्टर",
    login: "लॉगिन",
    platform: "प्लेटफॉर्म",
    solutions: "समाधान",
    getStarted: "शुरू करें",
    letsBuild1: "आइए मिलकर",
    letsBuild2: "बेहतर निर्माण करें।",
    requestDemoBtn: "डेमो का अनुरोध करें",
    stayConnected: "जुड़े रहें",
    links: {
      Overview: "अवलोकन",
      Features: "विशेषताएं",
      Services: "सेवाएं",
      Health: "स्वास्थ्य",
      Education: "शिक्षा",
      Government: "सरकार",
      NGOs: "एनजीओ",
      RegisterNow: "अभी रजिस्टर करें",
      Login: "लॉगिन",
      RequestaDemo: "डेमो का अनुरोध करें"
    },
    bottomLinks: {
      privacy: "गोपनीयता नीति",
      terms: "सेवा की शर्तें",
      security: "डेटा सुरक्षा",
      compliance: "अनुपालन"
    }
  },
  privacy: {
    h1: "गोपनीयता नीति"
  }
};